import { useState, useEffect } from "react";
import { Row, Col, Form, Modal, CloseButton } from "react-bootstrap";
import { SubmitButton, CancelButton } from "../shared";

export function NewRunModal({ show, onHide, onCreate, isCreating }) {
  const [name, setName] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  useEffect(() => {
    if (!show) return;
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth();
    const firstOfMonth = new Date(y, m, 1).toISOString().slice(0, 10);
    const lastOfMonth = new Date(y, m + 1, 0).toISOString().slice(0, 10);
    setStart(firstOfMonth);
    setEnd(lastOfMonth);
    setName(
      new Date(y, m, 1).toLocaleDateString("en-US", { month: "long" }) +
        " " +
        y +
        " payout run",
    );
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      scrollable
      className="commission-modal-scope new-run-modal"
    >
      <Modal.Header className="align-items-start">
        <div>
          <Modal.Title as="h2" className="fs-5">
            New payout run
          </Modal.Title>
        </div>
        <CloseButton onClick={onHide} aria-label="Close" />
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3" controlId="runName">
          <Form.Label className="text-secondary small">Run name</Form.Label>
          <Form.Control
            className="commission-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Form.Group>

        <Row className="g-3">
          <Col xs={6}>
            <Form.Group controlId="periodStart">
              <Form.Label className="text-secondary small">
                Period start
              </Form.Label>
              <Form.Control
                className="commission-input"
                type="date"
                value={start}
                onChange={(e) => setStart(e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col xs={6}>
            <Form.Group controlId="periodEnd">
              <Form.Label className="text-secondary small">
                Period end
              </Form.Label>
              <Form.Control
                className="commission-input"
                type="date"
                value={end}
                onChange={(e) => setEnd(e.target.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CancelButton onClick={onHide} />
        <SubmitButton
          text="Create"
          color="blue"
          disabled={!name || !start || !end}
          isSubmitting={isCreating}
          onClick={() => onCreate({ name, start, end })}
        />
      </Modal.Footer>
    </Modal>
  );
}
